import { GG_ENVIRONMENT_SET } from '../actions/ggEnvironmentSet';

type GgEnvironmentState = SensoryLinkEnvironment | null;

const initialState: GgEnvironmentState = null;

export default function ggEnvironment(
  state: GgEnvironmentState = initialState,
  action: any,
) {
  switch (action.type) {
    case GG_ENVIRONMENT_SET:
      return action.payload;

    default:
      return state;
  }
}